import { createStore, createEffect } from "effector"

import ApiService from "services/ApiService"
import { ApiLinkEntity, ApiLinkRel, ApiServiceName } from "config/constants"
import { Guid } from "@/types"
import Unit, { IUnitDto } from "models/Unit"
import { useUnit } from "effector-react"
import { useCallback } from "react"
import toastMessages from "./toastMessages"

type UnitsStore = Unit[]

// Stores
const $units = createStore<UnitsStore>([])

// Effects
const fetchUnitsFx = createEffect(async (): Promise<UnitsStore> => {
    try {
        const data: IUnitDto[] = await ApiService.request({
            serviceName: ApiServiceName.article,
            followLink: {
                entity: ApiLinkEntity.measurementSystem,
                rel: ApiLinkRel.all
            }
        })
        return data.map(dto => new Unit(dto))
    } catch (e) {
        console.error(e)
        toastMessages.showSystemError()
        return []
    }
})

// Listeners
$units.on(fetchUnitsFx.doneData, (_, payload) => payload)

// Exports
export default {
    $units,
    fetchUnits: fetchUnitsFx,
}

export function useUnits() {
    const units = useUnit($units)

    const getUnit = useCallback((unitId?: Guid): Unit | null => {
        if (!unitId || !units || units.length === 0) return null
        return units.find(u => u.id === unitId) || null
    }, [units])

    const printUnit = useCallback((unitId?: Guid): string => {
        return getUnit(unitId)?.print() || ""
    }, [getUnit])

    const printUnitShort = useCallback((unitId?: Guid): string => {
        return getUnit(unitId)?.printShort() || ""
    }, [getUnit])

    return {
        units,
        getUnit,
        printUnit,
        printUnitShort,
    }
}
